import { Injectable } from "@angular/core";
import { catchError, map, of } from "rxjs";
import { ApiService } from "src/app/_core/_services/api.service";
import { Holiday } from "../_models/holiday";

@Injectable({
  providedIn: "root",
})
export class HolidaysService {
  constructor(private api: ApiService) {}

  getPublicHolidays() {
    return this.api.getAPI("public-holidays").pipe(
      map((res: any) => {
        // console.log("Full response body:", res.body);
        return res.body.holidays; // Access the holidays from the body of the response
      }),
      catchError((error) => {
        console.error("Error fetching holidays:", error);
        return of([]); // Return an empty array in case of an error
      })
    );
  }
}
